import React, { useRef } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './ui/SectionHeading';
export function Testimonials() {
  const trackRef = useRef<HTMLUListElement>(null);
  const scrollBy = (dir: -1 | 1) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('li');
    const amount = card ? card.clientWidth + 16 : track.clientWidth * 0.85;
    track.scrollBy({
      left: amount * dir,
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-bone py-14 sm:py-20 lg:py-24" data-id="element-194" data-mp="2x004d0adz0xs">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-195" data-mp="2x2mlnrn2wut7">
        <SectionHeading overline="Historias reales" title={<>
              Ellas ya comenzaron a crear{' '}
              <span className="italic text-terracotta-500" data-id="element-197" data-mp="v8wvafg59ufc">
                sus propias esferas
              </span>
            </>} subtitle="Miles de mujeres están descubriendo una nueva forma de disfrutar la Navidad" data-id="element-196" data-mp="2s308tjb5xgkx" />

        <ul ref={trackRef} className="no-scrollbar mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 sm:mt-11 sm:gap-5" data-id="element-198" data-mp="h814jfcje0g9">
          {testimonials.map(t => <li key={t.name} className="flex w-[86%] flex-none snap-center flex-col rounded-3xl border border-gold-200/60 bg-cream p-5 shadow-[0_20px_44px_-34px_rgba(14,35,21,0.6)] sm:w-[48%] sm:p-7 lg:w-[32%]" data-id="element-199" data-mp="78tt4xpd4fvs">
              <div className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="zxr3menc18dz">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-201" data-mp="q6wbitnenekm" data-mpi={i} />)}
              </div>

              <blockquote className="mt-4 flex-1 text-[14px] leading-relaxed text-ink-soft sm:text-[14.5px]" data-id="element-202" data-mp="v4o3toryp2pc">
                “{t.quote}”
              </blockquote>

              <div className="mt-5 flex items-center gap-3 border-t border-gold-200/60 pt-4 sm:mt-6 sm:pt-5" data-id="element-203" data-mp="1nm0kd25ov5y9">
                <img src={t.avatar} alt={t.name} loading="lazy" className="h-11 w-11 flex-none rounded-full object-cover sm:h-12 sm:w-12" data-id="element-204" data-mp="1xiitaylvbojr" />
                <div data-id="element-205" data-mp="1sjfn3au5jca7">
                  <p className="font-serif text-[1.1rem] leading-tight text-sage-800 sm:text-[1.15rem]" data-id="element-206" data-mp="1sgter8zfssqx">
                    {t.name}
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 text-[12px] font-medium text-ink-light" data-id="element-207" data-mp="1jh6dqoamdoye">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-208" data-mp="1ek6fv0nxbsid" />
                    {t.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-7 flex items-center justify-center gap-3" data-id="element-209" data-mp="14ud49zns7de4">
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Testimonio anterior" className="flex h-12 w-12 items-center justify-center rounded-full border border-gold-200 bg-cream text-sage-800 transition-colors duration-200 ease-soft hover:bg-shell focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage-700" data-id="element-210" data-mp="10s9urgkoaivh">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-211" data-mp="32j9xmjpd1ghv" />
          </button>
          <button type="button" onClick={() => scrollBy(1)} aria-label="Testimonio siguiente" className="flex h-12 w-12 items-center justify-center rounded-full border border-gold-200 bg-cream text-sage-800 transition-colors duration-200 ease-soft hover:bg-shell focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage-700" data-id="element-212" data-mp="37i3d2ho7jhko">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-213" data-mp="2oq0u2zo3fp79" />
          </button>
        </div>
      </div>
    </section>;
}